// extracted by mini-css-extract-plugin
module.exports = {"button":"AvatarMoon_button__3K4ix","full-width-avatar":"AvatarMoon_full-width-avatar__11wDV","container":"AvatarMoon_container__2YJvg","image":"AvatarMoon_image__2Gb6n"};